import Box from '@mui/material/Box';
import { TrendingUp } from 'lucide-react';

export function BrandMark() {
  return (
    <Box
      aria-hidden
      sx={{
        width: 32,
        height: 32,
        borderRadius: 1,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        display: 'grid',
        placeItems: 'center',
        flexShrink: 0,
        boxShadow: '0 1px 2px rgba(37, 99, 235, 0.35)',
      }}
    >
      <TrendingUp size={18} strokeWidth={2} />
    </Box>
  );
}
